
export default {
  name: 'ProductListingCompactCardRevamp',

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleCTAButtonClicked(event, dataMainButtonCTA) {

      if (dataMainButtonCTA?.type === 'popup') {
        this.toggleDecoderCTAModal(dataMainButtonCTA.popupData);
        return;
      }
    },

    toggleDecoderCTAModal(popupData) {
      this.$store.commit('modal/setShowDecoderCTAModal', true);
      popupData.trackingData = {
        scenarioCode: this.data.id,
        productName: this.data.productName,
        category: this.data.category,
        insurerName: this.data.insuranceCompany.name,
        insurerCode: this.data.insuranceCompany.code,}
      this.$store.commit('modal/setDecoderCTAModalData', popupData);
    }
  },
};
